/*document.addEventListener("DOMContentLoaded", function () {



  var t = document.body.classList;

  var l = document.querySelector(
    "section#shopify-section-template--16703361187979__featured_collection_3PYLxW"
  );
  if (l) {
    var i = l.querySelectorAll("li"),
      a = ["#ff4cb661", "#8cd4f5a3", "#fea4b08c", "#4aade094"];
    i.forEach(function (e, t) {
      e.addEventListener("mouseenter", function () {
        t < a.length && (l.style.backgroundColor = a[t]);
      }),
        e.addEventListener("mouseleave", function () {
          l.style.backgroundColor = "";
        });
    });
  }

  // setInterval(function () {
  //   let e = document.querySelectorAll(
  //     "h2.mobile-facets__heading, h2.facet-filters__label, h2.product-count__text"
  //   );
  //   e.forEach(function (e) {
  //     let t = document.createElement("p");
  //     (t.innerHTML = e.innerHTML),
  //       Array.from(e.attributes).forEach((e) =>
  //         t.setAttribute(e.name, e.value)
  //       ),
  //       e.parentNode.replaceChild(t, e);
  //   });
  // }, 300);



      // (function waitForButtonTextChange() {
      //   const button = document.querySelector("button.shopify-payment-button__button--unbranded");

      //   if (button && button.textContent.trim() === "Buy it now") {
      //     button.textContent = "Buy Now";
      //     return; // Done ✅
      //   }

      //   // Try again on the next animation frame (efficient loop)
      //   requestAnimationFrame(waitForButtonTextChange);
      // })();


    (function waitForButtonTextChange() {
      const button = document.querySelector("button.shopify-payment-button__button--unbranded");

      if (button && button.textContent.trim() === "Buy it now") {
        button.textContent = "Buy Now";
        return; // Done ✅
      }

      // Try again on the next animation frame (efficient loop)
      requestAnimationFrame(waitForButtonTextChange);
    })();



  setTimeout(function () {
      var buttonText = document.querySelector('.sr-checkout-visible2');
      if (buttonText) {
        buttonText.textContent = 'Express Checkout';
      }
    }, 1000); // 1 second wait for third-party button to load



  // Run after DOM is fully loaded
 
    // Optional: Add a delay to ensure third-party buttons are loaded
    setTimeout(function () {
      // Select all elements with class 'sr-checkout-visible2'
      var buttonTexts = document.querySelectorAll('.sr-checkout-visible2');

      // Loop through each and change text if it's 'BUY NOW'
      buttonTexts.forEach(function (el) {
        if (el.textContent.trim().toUpperCase() === 'BUY NOW') {
          el.textContent = 'Express Checkout';
        }
      });
    }, 250); // Wait 1 second
 

});


*/



// document.addEventListener("DOMContentLoaded", function () {


  // const section = document.querySelector("section#shopify-section-template--16703361187979__featured_collection_3PYLxW");
  // if (section) {
  //   const items = section.querySelectorAll("li");
  //   const colors = ["#ff4cb661", "#8cd4f5a3", "#fea4b08c", "#4aade094"];
  //   items.forEach((item, index) => {
  //     item.addEventListener("mouseenter", () => {
  //       if (index < colors.length) section.style.backgroundColor = colors[index];
  //     });
  //     item.addEventListener("mouseleave", () => {
  //       section.style.backgroundColor = "";
  //     });
  //   });
  // }


//   const buyBtnObserver = new MutationObserver(() => {
//     const button = document.querySelector("button.shopify-payment-button__button--unbranded");
//     if (button && button.textContent.trim() === "Buy it now") {
//       button.textContent = "Buy Now";
//       buyBtnObserver.disconnect();
//     }
//   });
//   buyBtnObserver.observe(document.body, { childList: true, subtree: true });
//   function renameFastrrButtons() {
//     document.querySelectorAll(".sr-checkout-visible2").forEach(el => {
//       const text = el.textContent.trim().toUpperCase();
//       if (text === "BUY NOW" || text === "BUY IT NOW") {
//         el.textContent = "Express Checkout";
//       }
//     });
//   }
//   renameFastrrButtons();
//   setTimeout(renameFastrrButtons, 1000);
// });


function initBuyButtonScripts() {
  const buyBtnObserver = new MutationObserver(() => {
    const button = document.querySelector("button.shopify-payment-button__button--unbranded");
    if (button && button.textContent.trim() === "Buy it now") {
      button.textContent = "Buy Now";
      buyBtnObserver.disconnect();
    }
  });

  buyBtnObserver.observe(document.body, { childList: true, subtree: true });

  function renameFastrrButtons() {
    document.querySelectorAll(".sr-checkout-visible2").forEach(el => {
      const text = el.textContent.trim().toUpperCase();
      if (text === "BUY NOW" || text === "BUY IT NOW") {
        el.textContent = "Express Checkout";
      }
    });
  }

  renameFastrrButtons();
  setTimeout(renameFastrrButtons, 500);
}

// Run on page load + cart change
document.addEventListener("DOMContentLoaded", initBuyButtonScripts);
window.addEventListener("cart_changed", initBuyButtonScripts);





